import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { customerActions } from 'store';
import { FindLoad, Images, isAdmin } from 'utils';
import { Loader, PhoneRow, TextRow, TextToolTip, TypeRow } from 'components';

const ACTION_TYPE = 'GET_CUSTOMER_BY_ID';

export const CustomerInformation = ({ id }) => {
  const { customerById } = useSelector((state) => ({
      customerById: state.customers.customerById,
    }),
  );
  const dispatch = useDispatch();
  const loader = FindLoad(ACTION_TYPE);

  useEffect(() => {
    dispatch(customerActions.getCustomerById(id));
  }, []);
  const returnTypeText = (type, text, convert) => {
    return (
      <div className="type-and-text">
        <p>{type}</p>

        <span>{
          convert ?
            (
              type === 'Phone Number' ?
                <PhoneRow phone={text} />
                :
                <TypeRow text={text} />
            )
            :
            text ? text : '-'
        }</span>
      </div>
    );
  };

  return (
    <div className="customer-information-wrapper">
      {loader?.length ?
        <Loader height={'100%'} style={'relative'} />
        :

        <>
          <div className='align-center' style={{ gap: 12, marginBottom: '32px' }}>
            <p className="customer-title">{customerById?.name}</p>
            {(customerById?.prepaid && isAdmin) &&
              <TextToolTip
                wrapperStyles={{
                  width: '24px',
                  minWidth: '24px',
                  height: '24px',
                }}
                text={
                  <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                    <img
                      src={Images.dollarSvg}
                      alt='prepaid'
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                }
                content='Customer Prepaid'
                showTooltip
              />
            }
          </div>
          <div>
            <p className="basic-info">Basic Information</p>
            <div className="basic-info-wrapper">
              {returnTypeText('Type', customerById?.type, true)}
              {returnTypeText('MC Number', customerById?.mc)}
              {returnTypeText('Dot Number', customerById?.dot)}
            </div>

            <div className="basic-info-wrapper">
              {returnTypeText('Email Address', customerById?.email)}
              {returnTypeText('Billing Email', customerById?.billingEmail)}
              {returnTypeText('Phone Number', customerById?.phone, true)}
            </div>

            <div className="basic-info-wrapper">
              {returnTypeText('Payment term (days)', customerById?.pmtTerm)}
            </div>
          </div>

          <hr className="bottom-line-style" />

          {!!customerById?.contacts?.length > 0 &&
            <>
              <div style={{ marginBottom: 32 }}>
                <p className="basic-info">Contact Information</p>
                {customerById?.contacts?.map((i, j) => (
                  <div key={j} className="basic-info-row">
                    <div className="info-type-and-text" style={{ width: '30%' }}>
                      <p className="info-type-and-text-title">Contact Name:</p>
                      <TextRow name={i?.name} textWidth={12} />
                    </div>
                    <div className="info-type-and-text" style={{ width: '40%' }}>
                      <p className="info-type-and-text-title">Email Address:</p>
                      <TextRow name={i?.email} textWidth={12} />
                    </div>
                    <div className="info-type-and-text" style={{ width: '30%' }}>
                      <p className="info-type-and-text-title">Phone Number:</p>
                      <PhoneRow phone={i?.phone} />
                    </div>
                  </div>
                ))
                }
              </div>
              <hr className="bottom-line-style" />
            </>
          }


          {!!customerById?.creditInfo?.length > 0 &&
            <>
              <div style={{ marginBottom: 32 }}>
                <p className="basic-info">Credit Information</p>
                  {customerById?.creditInfo?.map((i, j) => (
                    <div key={j} className="basic-info-row">
                      <div className="info-type-and-text" style={{ width: '33%' }}>
                        <p className="info-type-and-text-title">Name:</p>
                        <TextRow name={i?.name} />
                      </div>
                      <div className="info-type-and-text" style={{ width: '33%' }}>
                        <p className="info-type-and-text-title">Score:</p>
                        <TextRow name={i?.score} />
                      </div>
                      <div className="info-type-and-text" style={{ width: '33%' }}>
                        <p className="info-type-and-text-title">DTP:</p>
                        <TextRow name={`${i?.daysToPay} days`} />
                      </div>
                    </div>
                  ))
                  }
              </div>
              <hr className="bottom-line-style" />
            </>
          }

          {customerById?.portalInfo?._id &&
            <>
              <div>
                <p className="basic-info">Portal Information</p>
                <div className="basic-info-wrapper">
                  {returnTypeText('Portal Name', customerById?.portalInfo?.name)}
                  {returnTypeText('Website', customerById?.portalInfo?.website)}
                  {returnTypeText('Password', customerById?.portalInfo?.password)}
                  {returnTypeText('Username', customerById?.portalInfo?.username)}
                </div>

                <div className="basic-info-wrapper">
                  {returnTypeText('Note:', customerById?.portalInfo?.notes)}
                </div>
              </div>
              <hr className="bottom-line-style" />
            </>
          }

          <div>
            <p className="basic-info">Address</p>
            <div className="basic-info-wrapper">
              {returnTypeText('Physical Address', customerById?.address?.formattedAddress)}
              {returnTypeText('Suit', customerById?.address?.unitNumber ? customerById?.address?.unitNumber : 'Not Set')}
              {returnTypeText('City', customerById?.address?.city ? customerById?.address?.city : 'Not Set')}
            </div>

            <div className="basic-info-wrapper">
              {returnTypeText('Country', customerById?.address?.country ? customerById?.address?.country : 'Not Set')}
              {returnTypeText('State', customerById?.address?.state ? customerById?.address?.state : 'Not Set')}
              {returnTypeText('Zip Code', customerById?.address?.zip ? customerById?.address?.zip : 'Not Set')}
            </div>
          </div>

          {customerById?.secondAddress &&
            <>
              <hr className="bottom-line-style" />
              <div>
                <p className="basic-info">Second Address</p>
                <div className="basic-info-wrapper">
                  {returnTypeText('Physical Address', customerById?.secondAddress?.formattedAddress)}
                  {returnTypeText('Suit', customerById?.secondAddress?.unitNumber ? customerById?.secondAddress?.unitNumber : 'Not Set')}
                  {returnTypeText('City', customerById?.secondAddress?.city ? customerById?.address?.city : 'Not Set')}
                </div>

                <div className="basic-info-wrapper">
                  {returnTypeText('Country', customerById?.secondAddress?.country ? customerById?.secondAddress?.country : 'Not Set')}
                  {returnTypeText('State', customerById?.secondAddress?.state ? customerById?.secondAddress?.state : 'Not Set')}
                  {returnTypeText('Zip Code', customerById?.secondAddress?.zip ? customerById?.secondAddress?.zip : 'Not Set')}
                </div>
              </div>
            </>
          }

        </>
      }
    </div>
  );
};